export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('scroll-to-hash', {
    mounted(el) {
      const route = useRoute();

      watch(() => route.hash, (hash) => {
        if (hash && hash === `#${el.id}`) {
          nextTick(() => {
            el.scrollIntoView({ behavior: 'smooth' });
          });
        }
      }, { immediate: true });
    }
  });
});
